@if (backdrop.isOpen()) {
  <div
    class="app-backdrop"
    [class.hide-on-desktop]="backdrop.activeItem()?.hideOnDesktop"
    [ngClass]="backdrop.activeItem()?.className"
    (click)="backdrop.backdropClick()"
  ></div>
}
